import { setUserProperties } from 'lib/analytics'
import { toBooleanString } from 'lib/helpers'
import { User } from 'lib/_types'
import { useGetUserCustomDefinitionsMutation } from 'store/api/yay/user'

export const useSetUserProperties = () => {
  const [getUserCustomDefinitions] = useGetUserCustomDefinitionsMutation({})

  const set = async (currentUser: User) => {
    const res = currentUser?.id && (await getUserCustomDefinitions({}))
    const customDefinitions = res && 'data' in res && res.data

    setUserProperties({
      user_age: customDefinitions?.age,
      created_at: customDefinitions?.created_at,
      followers_count: customDefinitions?.followers_count,
      followings_count: customDefinitions?.followings_count,
      last_loggedin_at: customDefinitions?.last_loggedin_at,
      reported_count: customDefinitions?.reported_count,
      status: customDefinitions?.status,
      user_id: currentUser?.id,
      is_vip: toBooleanString(currentUser?.vip),
      gender: currentUser?.gender,
      country_code: ['JP', 'TH', 'ID'].includes(currentUser?.country_code)
        ? (currentUser?.country_code as Parameters<
            typeof setUserProperties
          >[0]['country_code'])
        : '',
      login_streak_count: currentUser?.login_streak_count,
      age_verified: currentUser?.age_verified,
    })
  }

  return { set }
}
